import { BadgePoundSterling, MessagesSquare, MonitorSmartphone, PackageCheck, ShieldCheck, MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const TRUST_POINTS = [
  {
    title: "Clear package pricing",
    text: "Understand the starting cost and what is included before the project begins.",
    icon: BadgePoundSterling,
  },
  {
    title: "Direct communication",
    text: "Discuss your project directly and receive clear updates throughout the engagement.",
    icon: MessagesSquare,
  },
  {
    title: "Responsive design included",
    text: "Every website is designed to work properly across mobile, tablet and desktop.",
    icon: MonitorSmartphone,
  },
  {
    title: "Clear final handover",
    text: "Receive the completed agreed website through a defined approval, launch and handover stage.",
    icon: PackageCheck,
  },
  {
    title: "Secure enquiry process",
    text: "Project enquiries are handled through a protected form and sent privately to CLOSER.",
    icon: ShieldCheck,
  },
  {
    title: "UK-based service",
    text: "A focused digital studio serving ambitious businesses across the United Kingdom.",
    icon: MapPin,
  },
];

const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative z-10 py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <SectionHeading
        kicker="Why CLOSER."
        title="A Clearer Way to Build."
        sub="Straightforward standards you can rely on from the first conversation to final launch."
        testId="testimonials-heading"
      />
      <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
        {TRUST_POINTS.map((point, i) => {
          const Icon = point.icon;
          return (
          <Reveal key={point.title} i={i} className="h-full">
            <article
              data-testid={`testimonial-card-${i}`}
              className="group relative flex h-full flex-col rounded-3xl glass p-8 transition-[transform,background-color,border-color] duration-500 hover:-translate-y-2 hover:bg-white/[0.06] hover:border-white/25"
            >
              <Icon size={23} className="text-white/35 transition-colors duration-500 group-hover:text-white/70" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-base font-semibold tracking-tight text-white">{point.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-white/55">{point.text}</p>
            </article>
          </Reveal>
        )})}
      </div>
    </div>
  </section>
);

export default Testimonials;
